"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("../shared");
var configSettings = null;
var config = null;
function setup(params) {
    configSettings = params;
}
exports.setup = setup;
function init() {
    if (!config) {
        config = loadConfig();
    }
    return config;
}
exports.init = init;
function getConfig() {
    if (!config) {
        throw new Error('Config must be created before accessing it. Forgot to call init() before accessing config?');
    }
    return config;
}
exports.getConfig = getConfig;
function loadConfig() {
    var container = window._cianConfig;
    if (!container) {
        throw new Error("_cianConfig - not found in window");
    }
    if (!configSettings) {
        throw new Error('Settings key was not set for config. Forgot to call setup() before config initialization?');
    }
    var settingsKey = configSettings.settingsKey;
    var settings = container[settingsKey];
    if (!settings) {
        throw new Error("Missing settings in _cianConfig." + settingsKey);
    }
    if (!Array.isArray(settings)) {
        var msg = "Expecting array of settings in _cianConfig." + settingsKey + ". Got " + JSON.stringify(settings, null, 2);
        throw new Error(msg);
    }
    settings.forEach(function (setting) {
        if (!shared_1.validate(setting)) {
            throw new Error("Received unexpected entry in _cianConfig." + settingsKey + ": " + JSON.stringify(setting, null, 2));
        }
    });
    var source = new shared_1.Source(settings);
    return new shared_1.Config({ source: source });
}
//# sourceMappingURL=interface.js.map